package com.eladfinish.bible.contest.screens.randomVerse.usecases

import com.eladfinish.bible.contest.constants.StringConstants
import com.eladfinish.bible.contest.models.ClickableArea
import com.eladfinish.bible.contest.models.ClickableTextData
import com.eladfinish.bible.contest.screens.browse.usecases.GetIyovTehilimSpeakersUseCase
import com.eladfinish.bible.contest.screens.browse.usecases.GetIyovTehilimSpeakersUseCase.Companion.getVerseSpeaker

class ShowIyovFriendsUseCase(
    getIyovTehilimSpeakersUseCase: GetIyovTehilimSpeakersUseCase,
) {

    private val iyovSpeakers by lazy { getIyovTehilimSpeakersUseCase.getIyovSpeakers() }

    fun showIyovFriends(
        currentChapter: Int,
        currentPasuk: Int,
        onCorrectChapter: (Boolean) -> Unit,
    ): ClickableTextData {

        val actualSpeaker = iyovSpeakers.getVerseSpeaker(
            chapter = currentChapter,
            verse = currentPasuk,
            default = "איוב", // by default, a verse from Iyov is said by Iyov
        )
        val speakers = iyovSpeakers.map { it.name }

        val sb = StringBuilder()
        val clickableAreas = mutableListOf<ClickableArea>()

        sb.append("הדוברים בספר איוב:").append(StringConstants.FIVE_SPACES)
        for (speaker in speakers) {
            sb.append(speaker)
            clickableAreas.add(
                ClickableArea(
                    start = sb.length - speaker.length,
                    end = sb.length,
                    name = {
                        onCorrectChapter(speaker == actualSpeaker)
                    }
                )
            )
            sb.append(StringConstants.FIVE_SPACES)
        }
        sb.append("\n")

        return ClickableTextData(
            text = sb.toString(),
            clickableAreas = clickableAreas,
        )
    }

}
